import { render, staticRenderFns } from "./InClassDiscussionDetial.vue?vue&type=template&id=c26797d0&scoped=true"
import script from "./InClassDiscussionDetial.vue?vue&type=script&lang=js"
export * from "./InClassDiscussionDetial.vue?vue&type=script&lang=js"
import style0 from "./InClassDiscussionDetial.vue?vue&type=style&index=0&id=c26797d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26797d0",
  null
  
)

export default component.exports